import {QuoteWizardDefaultCustomViewController} from '../quoteWizardDefaultCustomView.controller';
import _ = require('lodash');
import {IQuoteWizardQuestionResponse} from '../../../models/quoteWizardQuestionResponse.model';
import {Constants} from '../../../../models/constants/marketplace.constants';

export class ClaimsInLastThreeYearsController extends QuoteWizardDefaultCustomViewController {
    public goNext(): void {
        if (this.stateService.viewModel.questionResponseGraph.anyClaimsInLastThreeYears.response === Constants.ClaimsInLastThreeYearsQuestionResponses.Yes) {
            // if they chose "not sure" before, that would set them all to null, and now they need to be either true or false
            // so set each response to false if it's empty
            // (skip if it already has a value so that if the user has previously checked a box for one, it won't uncheck it for them)
            // this will also serve to default all of the checkboxes to false (instead of undefined) the first time through the wizard
            //  which makes it easier if we are skipping those later
            this.setResponses(false, true);
        } else if (this.stateService.viewModel.questionResponseGraph.anyClaimsInLastThreeYears.response === Constants.ClaimsInLastThreeYearsQuestionResponses.No) {
            // explicitly set all of them to false per business rules
            this.setResponses(false);
        } else if (this.stateService.viewModel.questionResponseGraph.anyClaimsInLastThreeYears.response === Constants.ClaimsInLastThreeYearsQuestionResponses.NotSure) {
            // explicitly set all of them to null per business rules
            // noinspection TsLint
            this.setResponses(null);
        }
        super.goNext();
    }

    private setResponses(valueToSet: boolean, onlySetIfEmpty?: boolean) {
        const responses: Array<IQuoteWizardQuestionResponse<boolean>> = [
            // claim types responses
            this.stateService.viewModel.questionResponseGraph.anyPropertyClaimsInLastThreeYears,
            this.stateService.viewModel.questionResponseGraph.anyLiabilityClaimsInLastThreeYears,
            this.stateService.viewModel.questionResponseGraph.anyWorkCompClaimsInLastThreeYears,
            this.stateService.viewModel.questionResponseGraph.anyOwnedAutoClaimsInLastThreeYears,
            this.stateService.viewModel.questionResponseGraph.anyHiredNonOwnedAutoClaimsInLastThreeYears,
            this.stateService.viewModel.questionResponseGraph.anyOtherClaimsInLastThreeYears,
            // over 10k responses
            this.stateService.viewModel.questionResponseGraph.anyPropertyClaimsInLastThreeYearsOverTenThousand,
            this.stateService.viewModel.questionResponseGraph.anyLiabilityClaimsInLastThreeYearsOverTenThousand,
            this.stateService.viewModel.questionResponseGraph.anyWorkCompClaimsInLastThreeYearsOverTenThousand,
            this.stateService.viewModel.questionResponseGraph.anyOwnedAutoClaimsInLastThreeYearsOverTenThousand,
            this.stateService.viewModel.questionResponseGraph.anyHiredNonOwnedAutoClaimsInLastThreeYearsOverTenThousand,
            this.stateService.viewModel.questionResponseGraph.anyOtherClaimsInLastThreeYearsOverTenThousand
        ];

        _.each(responses, (response: IQuoteWizardQuestionResponse<boolean>) => {
            if (!onlySetIfEmpty || angular.isUndefined(response.response) || response.response === null)
                response.response = valueToSet;
        });
    }
}